import { ABTestingProvider } from './ABTestingProvider';

export default ABTestingProvider;
